import React from 'react'

export default function ServicesImage() {
  return (
    <>
    <section className="service-lastimg">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-9">
                    <img src="/image/service-image.webp" loading="lazy" class="img-responsive wow animate__animated animate__slideInUp" data-wow-duration="1.1s" data-wow-delay="0.2s" alt="service"/>
                </div>
            </div>
        </div>
    </section>  
    </>
  )
}
